import React from "react";
import { Checkbox, FormControlLabel, FormControl } from "@mui/material";

const CheckboxInput = ({ label, name, checked, onChange, required }) => {
  return (
    <FormControl required={required} sx={{ mb: 2 }}>
      <FormControlLabel
        control={
          <Checkbox
            name={name}
            checked={checked}
            onChange={(e) =>
              onChange({
                target: {
                  name,
                  value: e.target.checked,
                },
              })
            }
          />
        }
        label={label}
      />
    </FormControl>
  );
};

export default CheckboxInput;
